import React from 'react'
import Billboard from "../../components/Billboard";
import Links from "./Links/Links";
import MarkdownContent from './MarkdownContent'

const About = ({logo, name, description}) => {
    if(name && description){
        if(logo){
            return (
                <div className="row">
                    <div className="col-md-3">
                        <img src={logo} alt={name} className="img-thumbnail" />
                    </div>
                    <div className="col-md-9">
                        <h2>About {name}</h2>
                        <MarkdownContent className="CaseStudy__companyDescription" content={description} />
                    </div>
                </div>
            )
        }else{
            return (
                <div className="row">
                    <div className="col-md-12">
                        <h2>{name}</h2>
                        {description}
                    </div>
                </div>
            )
        }
    }
    else return null
}

const ChallengeBlock = ({challenges, solutions}) => {
    if(challenges && solutions){
        const challengeList = challenges.map((challenge, idx) => {
            return <li key={idx}>{challenge.title && <b>{challenge.title}: </b>}{challenge.text}</li>
        })
        const solutionList = solutions.map((solution, idx) => {
            return <li key={idx}>{solution}</li>
        })
        return (
            <div className="CaseStudy-challangeBlock">
                <div className="row">
                    <div className="col-md-6">
                        <h3>The Challenge</h3>
                        <ul>
                            {challengeList}
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <h3>The Solution</h3>
                        <ul>
                            {solutionList}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }else return null

}
const Results = ({results}) => {
    if(results){

        const resultList = results.map((result, idx)=>{
            const spanTitle = result.title.trim() ? <span className="CaseStudy--resultsBlock__h3">{result.title}</span> : ''
            return (
                <li key={idx}>
                    {spanTitle}
                    <div>
                        {result.text}
                    </div>
                </li>
            )
        })
        return (
            <div className="row>">
                <div className="col-md-12">
                    <div className="CaseStudy--resultsBlock">
                        <h2>THE BENEFITS</h2>
                        <ul>
                            {resultList}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }else return null

}


const TemplateCustom = ({frontmatter, html, fields}) => {
    const companyLogoUrl = fields.companyLogo.publicURL

    return (
        <>
            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">{frontmatter.title}</h1>
                    <div className="Billboard__lead">CASE STUDY</div>
                    <div className="Billboard__cta" />
                </div>
            </Billboard>

            <div className="CaseStudy">

                <section className="section blogWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9">
                                <div className="row CaseStudy--twoColumns">
                                    <About {...frontmatter.company} logo={companyLogoUrl} />
                                    <ChallengeBlock challenges={frontmatter.challenges} solutions={frontmatter.solutions} />
                                    <Results results={frontmatter.results} />
                                </div>
                                <article className="article">
                                    <div
                                        className="CaseStudy--html"
                                        dangerouslySetInnerHTML={{ __html: html }}
                                    />
                                </article>
                            </div>

                            <div className="col-md-3">
                                <div className="blogSidebar">
                                    <Links/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>


        </>
    )

}

export default TemplateCustom